module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h3 class="center">Roles list</h3>\r\n<table class="table table-hover top-margined">\r\n    <thead>\r\n    <tr>\r\n        <th>Role name</th>\r\n        <th>Type</th>\r\n        <th>Can View</th>\r\n        <th>Can Read All</th>\r\n        <th>Can Read For</th>\r\n        <th>Can Edit</th>\r\n        <th>Can Edit For</th>\r\n        <th>Can Edit All</th>\r\n        <th>Can Delete</th>\r\n        <th>Can Sign</th>\r\n        <th>Can Sign For All</th>\r\n        <th>Can Upload For</th>\r\n        <th>Can Change Reviewer</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody></tbody>\r\n</table>\r\n<div id="roles-form"></div>\r\n<div id="yes-no-confirmation-modal-for-update"></div>\r\n<div id="yes-no-confirmation-modal-for-delete"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/roles/roles.html
// module id = 450
// module chunks = 0